export const formatToMXN = (amount) => {
    return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
    }).format(amount);
};

export const transformString = (input) => {
    return input
        .toUpperCase() // Convert to uppercase
        .normalize("NFD") // Normalize to decompose accents
        .replace(/[\u0300-\u036f]/g, "") // Remove accents
        .replace(/\s+/g, "_"); // Replace spaces with "_"
}


export function isSameDate(date1, date2) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
}